const getters = {
  userName: state => state.app.userName,
  userStatus: state => state.app.userStatus
};
export default getters;